// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lai-product-card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 20px;
  margin: 20px 0px;
  height: 570px;
  width: 100%;
  overflow: hidden;
}

.lai-custom {
  border-radius: 20px;
  border: medium none currentColor;
  border: initial;
}
.lai-content-wrapper {
  padding: 10px 30px 20px 30px;
}

.lai-icon-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}

.icon-wrapper-a,
.icon-wrapper-b {
  display: flex;
  align-items: center;
}

.lai-icon-txt p {
  margin-bottom: 0px;
}

.card-img-top {
  height: 250px;
  width: 100%;
}

.lai-card-icon svg {
  padding-right: 10px;
}

.lai-card-icon img {
  height: 25px !important;
  width: auto;
  padding-right: 10px;
}

.lai-title-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 5px;
}

.lai-title h3 {
  margin-bottom: 0px;
  font-size: 22px;
}

.whishlist-icon svg {
  color: var(--dPink);
}

.lai-title-wrapper {
  border-top: 1px solid var(--LGrey);
  padding-top: 10px;
}

.product-desc {
  height: 65px !important;
}

.lai-text-rating-wrapper {
  border-bottom: 1px solid var(--LGrey);
}

.lai-text-rating-wrapper p {
  color: #000;
}

.lai-rating-wrapper {
  padding-top: 1%;
}
.buy-price-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.price-wrapper p {
  font-size: 20px;
  margin-bottom: 0;
}

.lai-buy-btn {
  background-color: var(--green);
  border: medium none currentColor;
  border: initial;
  font-weight: 700;
  padding: 5px 30px;
  font-size: 20px;
  color: #000;
}

.price-wrapper {
  text-align: end;
}

.lai-card-icon svg {
  font-size: 30px;
}

.lai-card-icon span {
  padding-left: 5px;
}
.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.product-desc p {
  color: black !important;
}

.spc-buy-btn:hover {
  background-color: var(--green);
}

.average-rating {
  margin-left: 10px;
}

.lai-title {
  height: 80px;
  width: 100%;
}

.lai-text-rating-wrapper {
  height: 100px;
}

.buy-yellow-btn {
  background-color: #ffba0b;
  color: #000000;
}

@media (max-width: 1024px) {
  .price-wrapper p {
    font-size: 14px;
  }

  .lai-product-card {
    height: 540px;
  }
}

@media (max-width: 576px) {
  .price-wrapper p {
    font-size: 16px;
  }

  .lai-title h3 {
    font-size: 16px;
  }

  .lai-title {
    height: 65px;
  }
}

@media only screen and (min-width: 1080px) and (max-width: 1200px) {
  .lai-product-card {
    height: 500px;
  }

  .card-img-top {
    height: 175px;
    width: 100%;
  }

  .price-wrapper p {
    font-size: 18px;
  }

  .lai-content-wrapper {
    padding: 10px 15px;
  }

  .product-desc {
    height: 70px !important;
  }

  .lai-icon-wrapper {
    padding: 0;
    padding: initial;
  }

  .lai-card-icon svg {
    font-size: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/common/cards/LAIProductCard.css"],"names":[],"mappings":"AAAA;EACE,4EAA4E;EAC5E,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAa;EAAb,eAAa;AACf;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAa;EAAb,eAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,UAAc;IAAd,gBAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".lai-product-card {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  border-radius: 20px;\n  margin: 20px 0px;\n  height: 570px;\n  width: 100%;\n  overflow: hidden;\n}\n\n.lai-custom {\n  border-radius: 20px;\n  border: unset;\n}\n.lai-content-wrapper {\n  padding: 10px 30px 20px 30px;\n}\n\n.lai-icon-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 10px;\n}\n\n.icon-wrapper-a,\n.icon-wrapper-b {\n  display: flex;\n  align-items: center;\n}\n\n.lai-icon-txt p {\n  margin-bottom: 0px;\n}\n\n.card-img-top {\n  height: 250px;\n  width: 100%;\n}\n\n.lai-card-icon svg {\n  padding-right: 10px;\n}\n\n.lai-card-icon img {\n  height: 25px !important;\n  width: auto;\n  padding-right: 10px;\n}\n\n.lai-title-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 10px;\n  margin-bottom: 5px;\n}\n\n.lai-title h3 {\n  margin-bottom: 0px;\n  font-size: 22px;\n}\n\n.whishlist-icon svg {\n  color: var(--dPink);\n}\n\n.lai-title-wrapper {\n  border-top: 1px solid var(--LGrey);\n  padding-top: 10px;\n}\n\n.product-desc {\n  height: 65px !important;\n}\n\n.lai-text-rating-wrapper {\n  border-bottom: 1px solid var(--LGrey);\n}\n\n.lai-text-rating-wrapper p {\n  color: #000;\n}\n\n.lai-rating-wrapper {\n  padding-top: 1%;\n}\n.buy-price-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.price-wrapper p {\n  font-size: 20px;\n  margin-bottom: 0;\n}\n\n.lai-buy-btn {\n  background-color: var(--green);\n  border: unset;\n  font-weight: 700;\n  padding: 5px 30px;\n  font-size: 20px;\n  color: #000;\n}\n\n.price-wrapper {\n  text-align: end;\n}\n\n.lai-card-icon svg {\n  font-size: 30px;\n}\n\n.lai-card-icon span {\n  padding-left: 5px;\n}\n.icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.product-desc p {\n  color: black !important;\n}\n\n.spc-buy-btn:hover {\n  background-color: var(--green);\n}\n\n.average-rating {\n  margin-left: 10px;\n}\n\n.lai-title {\n  height: 80px;\n  width: 100%;\n}\n\n.lai-text-rating-wrapper {\n  height: 100px;\n}\n\n.buy-yellow-btn {\n  background-color: #ffba0b;\n  color: #000000;\n}\n\n@media (max-width: 1024px) {\n  .price-wrapper p {\n    font-size: 14px;\n  }\n\n  .lai-product-card {\n    height: 540px;\n  }\n}\n\n@media (max-width: 576px) {\n  .price-wrapper p {\n    font-size: 16px;\n  }\n\n  .lai-title h3 {\n    font-size: 16px;\n  }\n\n  .lai-title {\n    height: 65px;\n  }\n}\n\n@media only screen and (min-width: 1080px) and (max-width: 1200px) {\n  .lai-product-card {\n    height: 500px;\n  }\n\n  .card-img-top {\n    height: 175px;\n    width: 100%;\n  }\n\n  .price-wrapper p {\n    font-size: 18px;\n  }\n\n  .lai-content-wrapper {\n    padding: 10px 15px;\n  }\n\n  .product-desc {\n    height: 70px !important;\n  }\n\n  .lai-icon-wrapper {\n    padding: unset;\n  }\n\n  .lai-card-icon svg {\n    font-size: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
